/*
  The gallery's video/3D opener. `ModalDialog` comes from the Atlas element bundle, which the
  atlas-dependencies embed injects asynchronously — so on a host theme this file (a plain
  `defer` script in the section) can run first. Referencing the class at parse time then threw
  "ModalDialog is not defined", `product-modal` never registered, and clicking a video in the
  gallery did nothing. Resolve the base class when it exists, and wait for the tag otherwise.
*/
(function () {
  function baseClass() {
    return window.ModalDialog || customElements.get('modal-dialog');
  }

  function defineProductModal(Base) {
    if (!Base || customElements.get('product-modal')) return;

    customElements.define(
      'product-modal',
      class ProductModal extends Base {
        constructor() {
          super();
        }

        hide() {
          super.hide();
        }

        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          const openedMediaId = this.openedBy.getAttribute('data-media-id');
          this.querySelectorAll(`[data-media-id]:not([data-media-id="${openedMediaId}"])`).forEach((element) => {
            element.classList.remove('active');
          });

          const activeMedia = this.querySelector(`[data-media-id="${openedMediaId}"]`);
          if (!activeMedia) return;

          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        }
      }
    );
  }

  if (baseClass()) {
    defineProductModal(baseClass());
  } else {
    customElements.whenDefined('modal-dialog').then(function (ModalDialogClass) {
      defineProductModal(baseClass() || ModalDialogClass);
    });
  }
})();
